import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

/** Кнопка включения Browser Notification в хедере */
export const NotificationsIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.text.primary,
}))
